import {Inject, Injectable} from '@angular/core';
import {BASE_CLIENT, BaseClient} from '../../client/base.client';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class AiAssistantService {

  constructor(private http: HttpClient,
              @Inject(BASE_CLIENT) private client: BaseClient) {
  }


  /**
   * 查询我的助手
   */
  getAiAssistant(systemCode: string) {
    let url = `${this.client.gateway}/auth/ai-assistant/findByUser`;
    if (systemCode) {
      url = url + `?systemCode=${systemCode}`;
    }
    return this.http.post(url, {}).pipe(
      map((response: any) => {
        return response.data ? response.data : [];
      })
    );
  }
}
